import kiccEasyCardQueries from '@apis/queries/kiccEasyCardQueries';
import { useFlow } from '@stackflow/react';
import useCalculatedRequest from '@store/order/hooks/useCalculatedRequest';
import { orderActions } from '@store/order/orderSlice';
import { useQuery } from '@tanstack/react-query';
import { saveTempOrder } from '@utils/restoreOrderUtils';
import { useState } from 'react';
import { useDispatch } from 'react-redux';

/** 간편카드 선택 상태와 적용. 선택을 눌러야 주문에 반영된다 */
function useOrderEasyCards() {
    const { push, pop } = useFlow();
    const dispatch = useDispatch();
    const request = useCalculatedRequest();
    const { easyCardId } = request;
    const { data } = useQuery(kiccEasyCardQueries.list());
    const cards = data?.cards;

    const [draftCardId, setDraftCardId] = useState<string | undefined>(easyCardId);
    // 고른 카드가 없으면 첫 번째 카드를 기본으로 선택한다
    const selectedCard = cards?.find((card) => card.cardId === draftCardId) ?? cards?.[0];

    const handleApply = () => {
        if (!selectedCard) {
            return;
        }
        dispatch(orderActions.setPaymentMethod('EASY_CARD'));
        dispatch(orderActions.setEasyCardId(selectedCard.cardId));
        pop();
    };

    const handleAdd = async () => {
        await saveTempOrder(request, 'EASY_CARD');
        push('EasyCardActivity', {});
    };

    return {
        cards,
        selectedCardId: selectedCard?.cardId,
        applyDisabled: !selectedCard,
        selectCard: setDraftCardId,
        handleApply,
        // 카드 등록은 간편카드 관리 화면에서 한다
        handleAdd,
        handleClose: pop,
    };
}

export default useOrderEasyCards;
